import {
  CLIENT_USER_MEMBER_TYPE,
  CLIENT_USER_ROLE,
  CLIENT_USER_STATUS,
} from '@api/types/client-user-management';
import { UserAction } from './types';

export const ACTION_MENU_ITEMS = {
  EDIT_ACCESS: 'Edit Access',
  MAKE_OWNER: 'Make Owner',
  CLONE_ACCESS: 'Clone Access',
  REMOVE_ACCESS: 'Remove Access',
} as const;

export const USER_ACTION_SUCCESS_TOASTS = {
  ACCESS_GRANTED: 'Access Granted Successfully',
  ACCESS_REMOVED: 'Access Removed Successfully',
  CHANGES_SAVED: 'Changes saved successfully',
} as const;

/** Modal modes for manage-users flows (invite, edit, assign owner, remove access, etc.). */
export enum USER_ACCESS_MODAL_MODE {
  INVITE = 'invite',
  CLONE_ACCESS = 'cloneAccess',
  EDIT_ACCESS = 'editAccess',
  REVIEW_ACCESS = 'reviewAccess',
  ASSIGN_OWNER = 'assignOwner',
  REMOVE_ACCESS = 'removeAccess',
}

export type UserAccessModalMode = USER_ACCESS_MODAL_MODE;

export const ROLE_DISPLAY_LABELS: Record<CLIENT_USER_ROLE, string> = {
  [CLIENT_USER_ROLE.OWNER]: 'Owner',
  [CLIENT_USER_ROLE.FULL_MEMBER]: 'Full Member',
  [CLIENT_USER_ROLE.MEMBER]: 'Member',
};

export const STATUS_DISPLAY_LABELS: Record<CLIENT_USER_STATUS, string> = {
  [CLIENT_USER_STATUS.ACTIVE]: 'Active',
  [CLIENT_USER_STATUS.INVITED]: 'Invited',
  [CLIENT_USER_STATUS.PENDING_DELETION]: 'Pending Deletion',
  [CLIENT_USER_STATUS.REVOKED]: 'Revoked',
};

export const MEMBER_TYPE_DISPLAY_LABELS: Record<CLIENT_USER_MEMBER_TYPE, string> = {
  [CLIENT_USER_MEMBER_TYPE.PRIMARY]: 'Primary',
  [CLIENT_USER_MEMBER_TYPE.SECONDARY]: 'Secondary',
};

export const ROLE_FILTER_OPTIONS = Object.values(CLIENT_USER_ROLE).map((role) => ({
  label: ROLE_DISPLAY_LABELS[role],
  value: role,
}));

export const STATUS_FILTER_OPTIONS = Object.values(CLIENT_USER_STATUS).map((status) => ({
  label: STATUS_DISPLAY_LABELS[status],
  value: status,
}));

export const DISABLED_ACTIONS_BY_ROLE: Partial<Record<CLIENT_USER_ROLE, UserAction[]>> = {
  [CLIENT_USER_ROLE.OWNER]: [ACTION_MENU_ITEMS.MAKE_OWNER],
};
